var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0389 24.9526L28.2941 20.2078C26.5995 18.5132 23.7188 19.1911 23.0409 21.394C22.5326 22.9192 20.838 23.7664 19.3129 23.4275C15.9237 22.5802 11.3484 18.1743 10.5011 14.6157C9.99273 13.0905 11.0095 11.3959 12.5346 10.8876C14.7375 10.2098 15.4154 7.32902 13.7208 5.63445L8.97599 0.88965C7.62033 -0.29655 5.58685 -0.29655 4.40065 0.88965L1.18096 4.10934C-2.03873 7.49848 1.51987 16.4797 9.48436 24.4442C17.4489 32.4087 26.4301 36.1368 29.8192 32.7476L33.0389 29.5279C34.2252 28.1723 34.2252 26.1388 33.0389 24.9526Z",
    fill: "#744DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7de1e7e06c7ef621ce4ab940334b1440.svg";
export { ForwardRef as ReactComponent };